export const techStacks = [
  {
    name: "React",
    content: [
      "컴포넌트 기반으로 재사용성과 유지보수성이 높은 UI를 개발했습니다.",
      "React.memo, useCallback, useMemo로 성능 최적화를 수행했습니다.",
      "Axios와 fetch를 사용해 API 비동기 통신과 상태 관리를 구현했습니다.",
      "Material UI와 Styled-components로 스타일링과 애니메이션을 적용한 경험이 있습니다.",
      "TDD를 통해 UI 기능을 테스트하고 검증한 경험이 있습니다.",
    ],
  },
  {
    name: "JavaScript",
    content: [
      "ES6+ 문법을 활용해 코드 가독성과 간결성을 높였습니다.",
      "비동기 처리로 API 호출과 데이터 로직을 효율적으로 구현했습니다.",
      "map, filter, reduce로 배열과 데이터 처리 성능을 최적화한 경험이 있습니다.",
      "Promise와 async/await로 비동기 흐름을 관리한 경험이 있습니다.",
      "이벤트 위임을 통해 복잡한 DOM 조작을 간소화했습니다.",
    ],
  },
  {
    name: "React Native",
    content: [
      "React Native로 안드로이드 앱을 개발한 경험이 있습니다.",
      "react-native-maps로 지도 및 위치 표시 기능을 구현했습니다.",
      "fetch를 사용해 RESTful API와의 비동기 통신을 처리했습니다.",
      "FlatList와 ScrollView로 목록과 스크롤 인터페이스를 구현했습니다.",
    ],
  },
  {
    name: "HTML/CSS",
    content: [
      "시멘틱 태그로 웹 표준을 준수한 마크업을 작성했습니다.",
      "Flexbox와 Grid를 활용해 반응형 디자인을 구현한 경험이 있습니다.",
      "Bootstrap을 사용해 일관된 레이아웃과 UI를 설계했습니다.",
      "CSS3 애니메이션으로 시각적 효과를 추가해 사용자 경험을 개선했습니다.",
    ],
  },
];
